import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { Chart as ChartCanvas } from "react-chartjs-2";

import { formatCents, formatCompetence } from "../../utils/directorFormat";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
);

const reais = (value) => (Number.isSafeInteger(value) ? value / 100 : null);

const CashflowMovementChart = ({ months = [] }) => {
  const data = {
    labels: months.map((month) => formatCompetence(month.competence)),
    datasets: [
      {
        type: "bar",
        label: "Entradas realizadas",
        data: months.map((month) => reais(month.inflow?.actualCents)),
        backgroundColor: "#245AE4",
        stack: "inflow",
        borderRadius: 4,
      },
      {
        type: "bar",
        label: "Entradas previstas",
        data: months.map((month) => reais(month.inflow?.forecastCents)),
        backgroundColor: "#8EAAF4",
        stack: "inflow",
        borderRadius: 4,
      },
      {
        type: "bar",
        label: "Saídas realizadas",
        data: months.map((month) => reais(month.outflow?.actualCents)),
        backgroundColor: "#FD3400",
        stack: "outflow",
        borderRadius: 4,
      },
      {
        type: "bar",
        label: "Saídas comprometidas",
        data: months.map((month) => reais(month.outflow?.committedCents)),
        backgroundColor: "#F18554",
        stack: "outflow",
        borderRadius: 4,
      },
      {
        type: "bar",
        label: "Saídas planejadas",
        data: months.map((month) => reais(month.outflow?.plannedUncommittedCents)),
        backgroundColor: "#F4BE8F",
        stack: "outflow",
        borderRadius: 4,
      },
      {
        type: "line",
        label: "Fluxo líquido",
        data: months.map((month) => reais(month.netFlowCents)),
        borderColor: "#5B45CC",
        backgroundColor: "#5B45CC",
        borderWidth: 2,
        pointRadius: 3,
        tension: 0.2,
        order: 0,
      },
      {
        type: "line",
        label: "Fluxo líquido acumulado",
        data: months.map((month) => reais(month.accumulatedNetFlowCents)),
        borderColor: "#1C2030",
        backgroundColor: "#1C2030",
        borderWidth: 3,
        pointRadius: 3,
        tension: 0.2,
        order: 0,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { intersect: false, mode: "index" },
    plugins: {
      datalabels: { display: false },
      legend: { position: "bottom", labels: { usePointStyle: true, boxWidth: 8 } },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${formatCents(Math.round(context.parsed.y * 100))}`,
        },
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: {
        grid: {
          color: (context) => (context.tick.value === 0 ? "#1C2030" : "#E9EDF4"),
          lineWidth: (context) => (context.tick.value === 0 ? 2 : 1),
        },
        ticks: { callback: (value) => formatCents(Math.round(Number(value) * 100)) },
      },
    },
  };

  return <section className="director-movement" aria-labelledby="director-movement-title">
    <header>
      <div>
        <span className="director-eyebrow">Entradas, saídas e diferença</span>
        <h2 id="director-movement-title">Movimento ao longo do período</h2>
      </div>
      <p>Valores realizados e futuros permanecem identificados na composição mensal.</p>
    </header>
    <div className="director-movement__canvas" aria-hidden="true">
      <ChartCanvas type="bar" data={data} options={options} />
    </div>
    <p className="director-movement__definition">
      O acumulado mostra a diferença entre entradas e saídas dentro do período selecionado. Ele não inclui o saldo bancário anterior ao período.
    </p>
  </section>;
};

export default CashflowMovementChart;
